import BaseService from "./BaseService";

export default class FormServices extends BaseService {
    public static getAllForms(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/getFormDetails', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }
    public static updateFormSubmission(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/updateSubmission', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static updateSubscription(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/zero/subscription', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static viewTranscript(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/viewTranscript', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static getIrsInterestDetails(token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'irs/getIrsInterestRate', {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
        });
    }
    public static downloadDocusignedPDF(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'irs/downloadForm', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static downloadPaymentLetter(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'irs/downloadLetter', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static UploadPDF(postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'irs/chatGpt/pdf', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postData)
        })
    }

    public static getAllKwongClaims(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'irs/getAllClaims', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    // Download Transcript Zip
    public static downloadTranscriptZip(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/downloadTranscriptZip', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    // Download Form843
    public static downloadForm843(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/downloadForm843', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    // Download Form843 attachment
    public static downloadForm843Attachment(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/downloadForm843Attachments', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static updateKwongPaymentReviewStatus(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'irs/updateKwongPaymentStatus', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static UploadTPData(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/html', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getEligiblePlans(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/getEligiblePlans', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }


    public static getTPData(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + `admin/html/irsResponse?time=${new Date().getTime()}`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static UploadPDFToGetEligiblePlans(postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/installmentPlans', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postData)
        })
    }

    public static updateForm433DResubmission(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'form433D/resubmitForm433D', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static getPaymentReviewPendingUsers(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/efaxreview/users', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static approvePaymentDoc(postData: any, token: string, isTransmitToIrs: boolean) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}admin/efaxreview/${isTransmitToIrs ? 'submit' : 'review'}`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static updateTaxpayerName(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'user/updateTaxpayerName', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }
}


